/**
 * Application-wide constants
 */

// Credit costs - Updated for exact pricing requirements
export const CREDIT_COSTS = {
  STANDARD_IMAGE: 10,      // Standard image generation
  HD_IMAGE: 25,            // HD image generation  
  WIDE_IMAGE: 25,          // Landscape/Portrait HD
  TALL_IMAGE: 25,          // Landscape/Portrait HD
  STANDARD_VIDEO: 120,     // Video Generation (5s)
  HD_VIDEO: 240,           // Video Generation (10s)
  ULTRA_HD_VIDEO: 240,     // Video Generation (10s)
  CHAT_MESSAGE: 0.2,
};

// Valid sizes for gpt-image-1 (square, portrait, landscape)
export const IMAGE_SIZES = [
  {
    label: 'Standard',
    value: '1024x1024',
    creditCost: CREDIT_COSTS.STANDARD_IMAGE,
    quality: 'standard', // maps to medium
    openaiSize: '1024x1024'
  },
  {
    label: 'Standard HD',
    value: '1024x1024_hd',
    creditCost: CREDIT_COSTS.HD_IMAGE,
    quality: 'hd', // maps to high
    openaiSize: '1024x1024'
  },
  {
    label: 'Landscape HD',
    value: '1536x1024',
    creditCost: CREDIT_COSTS.WIDE_IMAGE,
    quality: 'standard',
    openaiSize: '1536x1024'
  },
  {
    label: 'Portrait HD',
    value: '1024x1536',
    creditCost: CREDIT_COSTS.TALL_IMAGE,
    quality: 'standard',
    openaiSize: '1024x1536'
  }
];

// Video generation options - Updated for exact pricing requirements
export const VIDEO_SIZES = [
  { label: 'Square (960×960)', value: '960:960', creditCost: 120, duration: '5 seconds' },
  { label: 'Landscape HD (1280×720)', value: '1280:720', creditCost: 120, duration: '5 seconds' },
  { label: 'Portrait HD (720×1280)', value: '720:1280', creditCost: 120, duration: '5 seconds' },
  { label: 'Wide (1104×832)', value: '1104:832', creditCost: 120, duration: '5 seconds' },
  { label: 'Tall (832×1104)', value: '832:1104', creditCost: 120, duration: '5 seconds' },
  { label: 'Ultrawide (1584×672)', value: '1584:672', creditCost: 120, duration: '5 seconds' },
];

// Video durations - Fixed credit costs (no multipliers)
export const VIDEO_DURATIONS = [
  { label: 'Video Generation (5s)', value: 5, creditCost: 120 },
  { label: 'Video Generation (10s)', value: 10, creditCost: 240 }
];

// XGC Labs brand colors - Matched precisely to the design system screenshots
export const COLORS = {
  primary: '#1EDC0B',      // Vibrant neon green (main brand color)
  primaryDark: '#18B909',  // Darker green for contrast
  accent: '#FFFFFF',       // White accent
  background: '#000000',   // Pure black background (from screenshots)
  bgPattern: '#061806',    // Dark green for pattern
  card: '#0A180A',         // Slightly lighter card background
  text: '#FFFFFF',         // White for text
  textSecondary: '#BBBBBB',// Light gray for secondary text
  gray100: '#F8F8F8',      // Light gray from design system
  gray200: '#E6E6E6',      // Medium-light gray 
  gray300: '#BFBFBF',      // Medium gray
  gray400: '#999999',      // Medium-dark gray
  gray500: '#737373',      // Dark gray
  gray600: '#595959',      // Very dark gray
  gray700: '#272727'       // Almost black gray
};

// Gradients - Matched to XGC Labs design system screenshots
export const GRADIENTS = {
  primary: `linear-gradient(to right, rgba(0, 0, 0, 0.98), rgba(30, 220, 11, 0.92))`,
  hover: `linear-gradient(to right, rgba(30, 220, 11, 0.92), rgba(0, 0, 0, 0.98))`,
  greenGlow: `radial-gradient(circle at center, rgba(30, 220, 11, 0.5), transparent 70%)`,
};

// Animations
export const ANIMATIONS = {
  hover: {
    scale: 1.02,
    transition: { duration: 0.3 },
  },
  tap: {
    scale: 0.98,
    transition: { duration: 0.2 },
  },
  fadeIn: {
    opacity: [0, 1],
    y: [10, 0],
    transition: { duration: 0.5 },
  },
};

// Routes
export const ROUTES = {
  HOME: '/home',
  LOGIN: '/login',
  SIGNUP: '/signup',
  EMAIL_VERIFICATION: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  GENERATE: '/image',
  VIDEO: '/video',
  CHAT: '/chat',
  NFT_MAKER: '/nft-maker',
  DASHBOARD: '/dashboard',
  GALLERY: '/gallery',
  SETTINGS: '/settings',
  BUY_CREDITS: '/buy-credits',
  BUY_XGC: '/buy-xgc',
  PROFILE: '/profile',
  HELP: '/help',
  TUTORIAL: '/tutorial',
  PROMOTIONAL: '/promotional'
};

// Payment amounts
export const PAYMENT_AMOUNTS = {
  SMALL: 5,  // 5 credits
  MEDIUM: 20, // 20 credits
  LARGE: 50,  // 50 credits
}; 